// JsFromRoutes CacheKey 15a990b9f2f92eb05b9047c0e29949c4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/mp'),
  show: /* #__PURE__ */ definePathHelper('get', '/mp/:slug'),
  multiPlaceUserGift: /* #__PURE__ */ definePathHelper('get', '/u/:username/gifts/:slug'),
  create: /* #__PURE__ */ definePathHelper('post', '/mp'),
  draft: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug'),
  update: /* #__PURE__ */ definePathHelper('patch', '/mp/draft/:internal_slug'),
  updatePlaces: /* #__PURE__ */ definePathHelper('put', '/mp/draft/:internal_slug/places'),
  updateGiftTags: /* #__PURE__ */ definePathHelper('put', '/mp/draft/:internal_slug/gift_tags'),
  titleRecommendation: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug/title_recommendation'),
  guidebookRecommendation: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug/guidebook_recommendation'),
  descriptionRecommendation: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug/description_recommendation'),
  finishEditing: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug/finish_editing'),
  attributionUsers: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug/attribution_users'),
  copy: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug/copy'),
  giftSeries: /* #__PURE__ */ definePathHelper('get', '/mp/draft/:internal_slug/gift_series'),
  nationwidePlaceLocationsForCity: /* #__PURE__ */ definePathHelper('post', '/mp/draft/:internal_slug/nationwide_place_locations_for_city'),
  multiplaceGiftGiftlyNationwidePlaceLocationsForCity: /* #__PURE__ */ definePathHelper('post', '/mp/:slug/nationwide_place_locations_for_city'),
  multiplaceGiftWithUsernameNationwidePlaceLocationsForCity: /* #__PURE__ */ definePathHelper('post', '/u/:username/gifts/:slug/nationwide_place_locations_for_city'),
  vote: /* #__PURE__ */ definePathHelper('post', '/mp/:slug/vote'),
  unvote: /* #__PURE__ */ definePathHelper('delete', '/mp/:slug/vote'),
}
